import {destroy, get, post, put} from './../Client/BaseClient';

export const VehicleApi = {
    getVehicles: () =>
        get('Vehicle'),
    getVehicle: (id) =>
        get(`Vehicle/${id}`),
    getVehicleEhu: (id) =>
        get(`Vehicle/${id}/ElectronicHousingUnits`),
    createVehicle: (param) =>
        post('Vehicle', param),
    updateVehicle: (id, param) =>
        put(`Vehicle/${id}`, param),
    deleteVehicle: (id) =>
        destroy(`Vehicle/${id}`),
    remarkVehicle: (id, param) =>
        post(`Vehicle/${id}/Remarks`, param),
    editRemark: (id, text) =>
        post(`Vehicle/Remarks/Edit`, {id: id, remark: text}),
    deleteRemark: (id) =>
        destroy(`Vehicle/Remarks/${id}/Delete`),
    addEhu: (id, ehuId) =>
        put(`Vehicle/${id}/ElectronicHousingUnits/${ehuId}/Add`),
    removeEhu: (id, ehuId) =>
        put(`Vehicle/${id}/ElectronicHousingUnits/${ehuId}/Remove`),
    getVehicleParts: (id) =>
        get(`Vehicle/${id}/Parts`),
    addPart: (id, partId) =>
        put(`Vehicle/${id}/Parts/${partId}/Add`),
    removePart: (id, partId) =>
        put(`Vehicle/${id}/Parts/${partId}/Remove`),
};